"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _tab = _interopRequireDefault(require("@amzn/meridian-tokens/component/tab"));

var _context = _interopRequireDefault(require("./context"));

var _theme = require("../theme");

var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Styles
 */
var styles = (0, _emotion.css)({
  position: "relative",
  whiteSpace: "nowrap",
  display: "flex",
  width: "100%",
  overflowX: "auto",
  overflowY: "hidden"
});

var fillLineStyle = function fillLineStyle(t, _ref) {
  var type = _ref.type;
  return (0, _emotion.css)({
    width: "100%"
  }, type === "classic" ? {
    borderBottom: t.borderCss("border")
  } : {
    height: t("indicatorHeight"),
    marginTop: t("spacingVertical"),
    backgroundColor: t("indicatorColorDefault"),
    borderRadius: t("indicatorRadius"),
    alignSelf: "flex-end"
  });
};
/**
 * Used to group a set of tabs.
 */


var TabGroup = function TabGroup(props) {
  var children = props.children,
      fill = props.fill,
      onChange = props.onChange,
      type = props.type,
      value = props.value;
  var tabListRef = (0, _react.useRef)();
  var t = (0, _theme.useTheme)(_tab["default"], "tab");

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selectedIndex = _useState2[0],
      setSelectedIndex = _useState2[1];

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);

  var onMoveFocus = function onMoveFocus(key) {
    // Get a list of all the tabs in the tab list that aren't disabled
    var tabs = Array.from(tabListRef.current.querySelectorAll("[mdn-tab]:not([disabled])")); // Get the index of the currently focused tab

    var focusedTabIndex = tabs.findIndex(function (element) {
      return element === document.activeElement;
    }); // Determine if we're in an rtl context

    var rtl = getComputedStyle(tabListRef.current).direction === "rtl"; // Some helper

    var firstTab = tabs[0];
    var lastTab = tabs[tabs.length - 1]; // Move focus based on the user's key press

    switch (key) {
      // Focus on the first tab on "Home"
      case "Home":
        {
          firstTab.focus();
          break;
        }
      // Focus on the last tab on "End"

      case "End":
        {
          lastTab.focus();
          break;
        }
      // Focus on the next tab on "ArrowRight" wrapping to the first tab if
      // we're at the end

      case "ArrowRight":
        {
          var _tabs, _tabs2;

          var nextTab = rtl ? (_tabs = tabs[focusedTabIndex - 1]) !== null && _tabs !== void 0 ? _tabs : lastTab : (_tabs2 = tabs[focusedTabIndex + 1]) !== null && _tabs2 !== void 0 ? _tabs2 : firstTab;
          nextTab.focus();
          break;
        }
      // Focus on the previous tab on "ArrowLeft" wrapping to the last tab if
      // we're at the beginning

      case "ArrowLeft":
        {
          var _tabs3, _tabs4;

          var previousTab = rtl ? (_tabs3 = tabs[focusedTabIndex + 1]) !== null && _tabs3 !== void 0 ? _tabs3 : firstTab : (_tabs4 = tabs[focusedTabIndex - 1]) !== null && _tabs4 !== void 0 ? _tabs4 : lastTab;
          previousTab.focus();
          break;
        }
    }
  }; // Calculate the index of the selected tab. This value is used in "classic" Tab
  // styling because we still don't have a immediate, previous CSS selector 🙏


  (0, _react.useEffect)(function () {
    var tabs = Array.from(tabListRef.current.querySelectorAll("[mdn-tab]"));
    var selectedIndex = tabs.findIndex(function (element) {
      return element.getAttribute("mdn-tab-value") === value;
    });
    setSelectedIndex(selectedIndex);
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement(_context["default"].Provider, {
    value: {
      t: t,
      value: value,
      onChange: onChange,
      type: type,
      fill: fill,
      onMoveFocus: onMoveFocus,
      selectedIndex: selectedIndex
    }
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: styles,
    role: "tablist",
    id: props.id,
    ref: tabListRef
  }, passThroughProps), children, fill === "line" && /*#__PURE__*/_react["default"].createElement("div", {
    className: fillLineStyle(t, {
      type: type
    })
  })));
};

TabGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The Tab children for the TabGroup.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The value of the selected Tab.
   */
  value: _propTypes["default"].any.isRequired,

  /**
   * A function that will be called when the user attempts to change the
   * selected tab. The new value will be passed as the first argument to this
   * function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 6.2.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 6.2.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * Determines how the unused space in the Tab group is handled.
   *
   * - `"none"` will not fill the space; the width of each Tab depends on the length of its label.
   * - `"tabs"` uses an equal amount of padding for each Tab to span the total available width.
   * - `"line"` does not add additional padding to each Tab and fills the available width with a line.
   */
  fill: _propTypes["default"].oneOf(["none", "tabs", "line"]),

  /**
   * Sets an `id` attribute on the `role=tablist` element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 6.0.0
   */
  id: _propTypes["default"].string,

  /**
   * The visual style of the Tab group.
   */
  type: _propTypes["default"].oneOf(["default", "classic"])
} : {};
TabGroup.defaultProps = {
  fill: "none",
  type: "default"
};
var _default = TabGroup;
exports["default"] = _default;